import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  PublishDirectMessageFulfilledAction,
  PublishEditMessageFulfilledAction,
  PublishEventMessageFulfilledAction,
  PublishGroupMessageFulfilledAction,
  PublishNetworkQuestionMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
  PublishTeamsMeetingMessageFulfilledAction,
  PublishUserMessageFulfilledAction,
  PublishUserPollMessageFulfilledAction,
  PublishUserPraiseMessageFulfilledAction,
} from '../../domains/publishers/actions.types';

import type { PublishedMessages } from './types';

export type PublishedMessageAction =
  | PublishGroupMessageFulfilledAction
  | PublishUserMessageFulfilledAction
  | PublishUserPollMessageFulfilledAction
  | PublishUserPraiseMessageFulfilledAction
  | PublishDirectMessageFulfilledAction
  | PublishEditMessageFulfilledAction
  | PublishEventMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishTeamsMeetingMessageFulfilledAction
  | PublishNetworkQuestionMessageFulfilledAction;

const initialState = {};

const reducer: Reducer<PublishedMessages, PublishedMessageAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.messageId);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.messageId);
    case 'PUBLISHER.PUBLISH_TEAMS_MEETING_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    case 'PUBLISHER.PUBLISH_NETWORK_QUESTION_MESSAGE_FULFILLED':
      return addToRecord(state, action.payload.publisherId, action.payload.threadId);
    default:
      return state;
  }
};

export default reducer;
